<template>
  <div class="min-h-screen bg-slate-900 flex items-center justify-center px-4">
    <div class="w-full max-w-sm">

      <!-- Logo / cabecera -->
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl
                    bg-gradient-to-br from-emerald-500 to-emerald-700 shadow-lg mb-4">
          <i class="fa-solid fa-lock-open text-white text-2xl"></i>
        </div>
        <h1 class="text-2xl font-bold text-white">Nueva contraseña</h1>
        <p class="text-slate-400 text-sm mt-1">Elige una contraseña segura para tu cuenta</p>
      </div>

      <!-- Card -->
      <div class="bg-slate-800 rounded-2xl shadow-xl p-8 border border-slate-700">

        <!-- Éxito -->
        <div v-if="exito" class="text-center">
          <div class="text-5xl mb-4">✅</div>
          <h2 class="text-emerald-400 font-semibold text-lg mb-2">¡Contraseña actualizada!</h2>
          <p class="text-slate-300 text-sm leading-relaxed">
            Tu contraseña ha sido cambiada correctamente.<br>
            Ya puedes iniciar sesión con tu nueva contraseña.
          </p>
          <router-link :to="{ name: 'Login' }"
            class="mt-6 inline-block bg-gradient-to-r from-emerald-600 to-emerald-700
                   hover:from-emerald-500 hover:to-emerald-600
                   text-white font-semibold px-6 py-2.5 rounded-xl transition shadow-md text-sm">
            Ir al inicio de sesión →
          </router-link>
        </div>

        <!-- Token inválido -->
        <div v-else-if="tokenInvalido" class="text-center">
          <div class="text-5xl mb-4">❌</div>
          <h2 class="text-red-400 font-semibold text-lg mb-2">Enlace inválido o expirado</h2>
          <p class="text-slate-300 text-sm leading-relaxed">
            El enlace de restablecimiento no es válido o ha expirado.<br>
            Por favor solicita uno nuevo.
          </p>
          <router-link :to="{ name: 'OlvidePassword' }"
            class="mt-6 inline-block text-emerald-500 hover:text-emerald-300 text-sm transition">
            Solicitar nuevo enlace
          </router-link>
        </div>

        <!-- Formulario -->
        <form v-else @submit.prevent="restablecer">

          <!-- Error -->
          <div v-if="errorMsg"
            class="mb-4 bg-red-900/40 border border-red-500/50 text-red-300 text-sm px-4 py-3 rounded-xl">
            {{ errorMsg }}
          </div>

          <!-- Nueva contraseña -->
          <div class="mb-4">
            <label class="block text-sm font-medium text-slate-300 mb-2">
              <i class="fa-solid fa-lock mr-2 text-emerald-400"></i>Nueva contraseña
            </label>
            <input
              v-model="password"
              type="password"
              placeholder="Mínimo 6 caracteres"
              class="w-full bg-slate-700 text-white placeholder-slate-500
                     border border-slate-600 rounded-xl px-4 py-3 text-sm
                     focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition"
            />
          </div>

          <!-- Confirmar contraseña -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-slate-300 mb-2">
              <i class="fa-solid fa-lock mr-2 text-emerald-400"></i>Confirmar contraseña
            </label>
            <input
              v-model="confirmar"
              type="password"
              placeholder="Repite tu nueva contraseña"
              class="w-full bg-slate-700 text-white placeholder-slate-500
                     border border-slate-600 rounded-xl px-4 py-3 text-sm
                     focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition"
            />
          </div>

          <!-- Botón -->
          <button
            type="submit"
            :disabled="cargando"
            class="w-full bg-gradient-to-r from-emerald-600 to-emerald-700
                   hover:from-emerald-500 hover:to-emerald-600 disabled:opacity-60
                   text-white font-semibold py-3 rounded-xl transition shadow-md"
          >
            <span v-if="cargando">
              <i class="fa-solid fa-spinner fa-spin mr-2"></i>Guardando…
            </span>
            <span v-else>
              <i class="fa-solid fa-floppy-disk mr-2"></i>Guardar contraseña
            </span>
          </button>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import authService from '@/services/auth.service'

export default {
  name: 'RestablecerPasswordView',
  data () {
    return {
      password:     '',
      confirmar:    '',
      cargando:     false,
      exito:        false,
      tokenInvalido: false,
      errorMsg:     ''
    }
  },
  computed: {
    token () {
      return this.$route.query.token || ''
    }
  },
  created () {
    if (!this.token) {
      this.tokenInvalido = true
    }
  },
  methods: {
    async restablecer () {
      this.errorMsg = ''
      if (!this.password || !this.confirmar) {
        this.errorMsg = 'Por favor completa ambos campos.'
        return
      }
      if (this.password.length < 6) {
        this.errorMsg = 'La contraseña debe tener al menos 6 caracteres.'
        return
      }
      if (this.password !== this.confirmar) {
        this.errorMsg = 'Las contraseñas no coinciden.'
        return
      }
      this.cargando = true
      try {
        const { data } = await authService.restablecerPassword(this.token, this.password)
        if (data.resultado) {
          this.exito = true
        } else {
          if (data.mensaje && data.mensaje.toLowerCase().includes('expirado')) {
            this.tokenInvalido = true
          } else {
            this.errorMsg = data.mensaje || 'No se pudo restablecer la contraseña.'
          }
        }
      } catch {
        this.errorMsg = 'Ocurrió un error. Inténtalo más tarde.'
      } finally {
        this.cargando = false
      }
    }
  }
}
</script>
